import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_ARTICLE_BY_SLUG,
    getArticleBySlugFail,
    getArticleBySlugSuccess
} from '../action/getArticleBySlugAction'

// api 
import getArticleBySlugApi from '../api/getArticleBySlugApi'

export function* getArticleBySlugSaga(action) {
    try {
        const response = yield call(() => getArticleBySlugApi(action.params))
        if (response.data.status === 1) {
            yield put(getArticleBySlugSuccess(response, action))
        } else {
            yield put(getArticleBySlugFail(response, action))
        }
    }
    catch (e) {
        yield put(getArticleBySlugFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_ARTICLE_BY_SLUG, getArticleBySlugSaga)
}